import React from 'react';
import Button from 'components/UI/Button';

import Title from 'components/UI/Title';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

function UnauthorizedPage({ isB2cPage })
{
    const goHome = () =>
    {
        window.location.replace('/');
    };

    return (
        <div className="tw-flex tw-flex-col tw-h-screen tw-items-center tw-justify-center tw-w-full tw-overflow-y-auto tw-p-10">
            <Title title="401" className="primary" />
            You are not authorized to access this section.

            <div className="tw-flex tw-flex-col tw-w-40">
                <Button onClick={() => goHome()} content="Go to the home page" size="sm" />
            </div>

            <Helmet title={`Unauthorized | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Unauthorized" />
            </Helmet>

        </div>
    );
}

UnauthorizedPage.defaultProps = {
    isB2cPage: false,
};

UnauthorizedPage.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default UnauthorizedPage;
